import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import Button from '@mui/material/Button';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React from 'react';

import useStyles from './LikeButton.style';

export interface LikeButtonProps extends IconButtonProps {
  /**
   * class name passed to the button
   */
  className?: string;
  /**
   * determines the size of button & icon
   */
  large?: boolean;
  /**
   * determines if the icon is filled (has the item been saved?)
   */
  enabled?: boolean;
  /**
   * returns a different button with text
   */
  text?: boolean;
  /**
   * applies to the icon
   */
  variant?: 'contained' | 'outlined';
  /**
   * applies to the icon
   */
  outlinedColor?: string;
  /**
   * callback executed when the element is clicked
   */
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const LikeButton: React.FC<LikeButtonProps> = (props: LikeButtonProps) => {
  const { className, large, enabled, onClick, variant='contained', text, outlinedColor = '#080808', ...rest } = props;
  const { classes, cx, theme } = useStyles({ large, enabled, text, outlinedColor });

  if (!text) {
    return (
      <IconButton
        size="medium"
        className={cx(classes.button, className)}
        onClick={onClick}
        {...rest}
        aria-label={enabled ? 'Saved' : 'Save'}
      >
        {variant === 'contained' ? (
          <FavoriteIcon className={classes.heartIcon} />
        ) : enabled ? (
          <FavoriteIcon
            className={cx({
              [classes.heartIcon]: true,
              [classes.heartIconFull]: enabled
            })}
          />
        ) : <FavoriteBorderIcon className={classes.heartIconOutlined} />}
      </IconButton>
    );
  }

  return (
    <Button
      size="small"
      className={className}
      color="secondary"
      aria-label={enabled ? 'Saved' : 'Save'}
      startIcon={variant === 'contained' ? (
        <FavoriteIcon
          className={cx({
            [classes.heartIcon]: true,
            [classes.textButton]: true,
          })}
        />
      ) : enabled ? (
        <FavoriteIcon
          className={cx({
            [classes.heartIcon]: true,
            [classes.heartIconFull]: enabled,
            [classes.textButton]: true,
          })}
        />
      ) : <FavoriteBorderIcon
        className={cx({
          [classes.heartIconOutlined]: true,
          [classes.textButton]: true
        })}
      />}
      onClick={onClick}
    >
      <Typography
        style={{
          fontFamily: theme.typography.fontFamily,
          marginLeft: theme.spacing(3.5),
        }}
      >
        Save
      </Typography>
    </Button>
  );
};

export default LikeButton;
